import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md column",
  style: {"width":"400px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-md text-weight-regular" }, "Ladda upp fil", -1)
const _hoisted_3 = { class: "full-width" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "column full-width" }
const _hoisted_6 = { class: "row q-pt-sm" }
const _hoisted_7 = {
  key: 0,
  class: "row q-pt-md"
}
const _hoisted_8 = { class: "text-red text-caption" }
const _hoisted_9 = {
  key: 1,
  class: "row q-pt-md"
}
const _hoisted_10 = { class: "text-green text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_file, {
            filled: "",
            modelValue: _ctx.file,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.file) = $event)),
            label: "Välj fil",
            accept: ".csv",
            disable: _ctx.fileUploading,
            loading: _ctx.fileUploading
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "mdi-cloud-upload" })
            ]),
            append: _withCtx(() => [
              (!_ctx.fileUploading)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "mdi-close",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.file = null), ["stop"])),
                    class: "cursor-pointer"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "disable", "loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          class: "q-ml-auto",
          onClick: _ctx.uploadFile,
          disable: !_ctx.file
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ladda upp fil")
          ]),
          _: 1
        }, 8, ["onClick", "disable"])
      ]),
      (_ctx.fileErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_q_banner, {
              dense: "",
              class: "bg-grey-3"
            }, {
              avatar: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  size: "sm",
                  name: "mdi-alert-circle-outline",
                  color: "red"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fileErrorMessage), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.fileSuccessMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_q_banner, {
              dense: "",
              class: "bg-grey-3",
              style: {"width":"100%"}
            }, {
              avatar: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  size: "sm",
                  name: "mdi-checkbox-marked-circle-outline",
                  color: "green"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.fileSuccessMessage), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}